module.exports = __webpack_public_path__ + "img/notification.eaee5a62.svg";